
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class editGWattMinM3LayerModal extends Vue {

    @Prop() productionProcessName: string;
    @Prop() emissionCalculation: OM.GWattMinM3Model;
    @Prop() saveCallback: (updatedModel: OM.GWattMinM3Model) => void;

    localModel = new OM.GWattMinM3Model();

    created() {
        this.localModel = this.emissionCalculation;
    }

    get disabled(){
        return !this.localModel.grams.value || !this.localModel.watt.value || !this.localModel.minutes.value || !this.localModel.m3.value;
    }

    save() {
        this.saveCallback(this.localModel);
    }
}
